import { Mail } from 'lucide-react';

const UNSUBSCRIBE_EMAIL = 'noreply@vägförening.se';

export default function UnsubscribePage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-teal-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md text-center space-y-4">
        <h1 className="text-2xl font-bold text-gray-900">Avsluta sms/e-postutskick</h1>
        <p className="text-gray-600">
          Skicka ett mejl till oss med den e-postadress och/eller det telefonnummer du vill avanmäla, så tar vi bort
          det manuellt.
        </p>
        <a
          href={`mailto:${UNSUBSCRIBE_EMAIL}`}
          className="inline-flex items-center gap-2 text-teal-700 hover:text-teal-800 font-medium"
        >
          <Mail className="w-4 h-4" />
          {UNSUBSCRIBE_EMAIL}
        </a>
      </div>
    </div>
  );
}
